import { match, P } from 'ts-pattern';
import { useShallow } from 'zustand/react/shallow';

import { cn } from '@nesso/ui/lib/utils';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@nesso/ui/primitives/alert-dialog';

import { confirmDialogVariants, useConfirmDialogStore } from '@/shared/stores/confirm-dialog-store';

const widthClasses = {
    '2xs': 'sm:max-w-2xs',
    xs: 'sm:max-w-xs',
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-md',
    lg: 'sm:max-w-lg',
} as const;

export function ConfirmDialog() {
    const { isOpen, props } = useConfirmDialogStore(
        useShallow((state) => ({
            isOpen: state.isOpen,
            props: state.props,
        })),
    );
    const close = useConfirmDialogStore((state) => state.close);

    const { cancelVariant, confirmVariant } = confirmDialogVariants[props?.variant || 'default'];

    return (
        <AlertDialog
            open={isOpen}
            onOpenChange={(open) => {
                if (!open) {
                    props?.onClose?.();
                    close(false);
                }
            }}
        >
            <AlertDialogContent className={cn(widthClasses[props?.width || 'lg'])}>
                <AlertDialogHeader>
                    <AlertDialogTitle>{props?.title}</AlertDialogTitle>
                    {match(props?.description)
                        .with(P.nullish, () => null)
                        .otherwise((node) => (
                            <AlertDialogDescription className="tracking-wide tabular-nums whitespace-pre-line">
                                {node}
                            </AlertDialogDescription>
                        ))}
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={() => close(false)} variant={cancelVariant}>
                        {props?.cancelText || 'Cancel'}
                    </AlertDialogCancel>
                    <AlertDialogAction onClick={() => close(true)} variant={confirmVariant}>
                        {props?.confirmText || 'Confirm'}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
